module.exports = __webpack_public_path__ + "static/media/message-delivered.7c97ea9d.svg";